import React, {Component, createRef} from 'react';
import {DataTable} from 'primereact/datatable';
import {Column} from 'primereact/column';
import {Toast} from 'primereact/toast';
import {Button} from 'primereact/button';
import {Toolbar} from 'primereact/toolbar';
import {InputText} from 'primereact/inputtext';
import {I18n} from "react-redux-i18n";
import {Dropdown} from "primereact/dropdown";
import {Order} from "../helpers/order";
import {connect} from "react-redux";
import TransactionService from "../services/TransactionService";
import {Menu} from "primereact/menu";
import {
    formatAmount,
    formatCustomDate,
    getFormErrorMessage,
    isFormFieldInvalid
} from "../helpers/utils";
import {Tag} from "primereact/tag";
import {MultiSelect} from "primereact/multiselect";
import {Formik} from "formik";
import {classNames} from "primereact/utils";
import {InputTextarea} from "primereact/inputtextarea";
import {InputNumber} from "primereact/inputnumber";
import {Dialog} from "primereact/dialog";
import * as Yup from "yup";

class Transaction extends Component {

    constructor(props) {
        super(props);

        this.formikRefundProps = {
            enableReinitialize: true,
            initialValues: {
                amount: null,
                reason: ''
            },
            validationSchema: Yup.object().shape({
                reason: Yup.string().required(I18n.t('FIELD_IS_REQUIRED')),
                amount: Yup.number()
                    .positive(I18n.t('FIELD_MUST_BE_POSITIVE'))
                    .required(I18n.t('FIELD_IS_REQUIRED'))
                    .typeError(I18n.t('FIELD_IS_REQUIRED'))
            }), onSubmit: (element) => {
                this.saveRefund(element)
            }
        };

        this.formikCommentProps = {
            enableReinitialize: true,
            initialValues: {
                comment: ''
            },
            validationSchema: Yup.object().shape({
                comment: Yup.string().required(I18n.t('FIELD_IS_REQUIRED'))
            }), onSubmit: (element) => {
                this.saveComment(element)
            }
        };

        this.menuRefs = new Map();
        this.formikRefundRef = React.createRef();
        this.formikCommentRef = React.createRef();

        this.state = {
            loading: false,
            loadingDialog: false,
            refundDialog: false,
            commentDialog: false,
            first: 0,
            pageSize: 20,
            totalRecords: 0,
            elements: [],
            selectedElement: null,
            selectedElements: [],
            transactionColumns: [],
            searchFilterValue: '',
            sortFilterValue: null,
            selectedColumns: ['REASON'],
            sortFilterOrder: 1,
        };

        this.elementService = new TransactionService();
        this.statTemplate = this.statTemplate.bind(this);
        this.leftToolbarTemplate = this.leftToolbarTemplate.bind(this);
        this.rightToolbarTemplate = this.rightToolbarTemplate.bind(this);
        this.searchTemplate = this.searchTemplate.bind(this);
        this.loadData = this.loadData.bind(this);
        this.onPage = this.onPage.bind(this);
        this.hideElementDialog = this.hideElementDialog.bind(this);
        this.renderRefundFooter = this.renderRefundFooter.bind(this);
        this.saveRefund = this.saveRefund.bind(this);
        this.saveComment = this.saveComment.bind(this);
        this.renderCommentFooter = this.renderCommentFooter.bind(this);
        this.onTransactionColumnsChange = this.onTransactionColumnsChange.bind(this);
    }

    componentDidMount() {
        this.createColumns();
        this.loadData({
            businessIdentifier: this.props.business?.current?.identifier,
            isLive: this.props.business?.isBusinessProduction,
            start: 0,
            pageSize: this.state.pageSize,
            sortField: this.state.sortFilterValue,
            order: this.state.sortFilterOrder,
            searchValue: this.state.searchFilterValue,
        });
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (prevProps.locale !== this.props.locale) {
            this.createColumns();
        }
    }

    createColumns() {
        const transactionColumns = [
            {name: I18n.t('PAYMENT_REASON'), value: 'REASON'},
            {name: I18n.t('QUANTITY'), value: 'QUANTITY'},
            {name: I18n.t('COMMENT'), value: 'COMMENT'},
            {name: I18n.t('PLATFORM_FEES'), value: 'FEES'},
            {name: I18n.t('TOTAL_AMOUNT'), value: 'TOTAL'},
        ];

        this.setState({
            transactionColumns
        });
    }

    onTransactionColumnsChange(e) {
        console.log(e.value);
        this.setState({selectedColumns: e.value})
    }

    findIndexByIdentifier(identifier) {
        let index = -1;
        for (let i = 0; i < this.state.elements.length; i++) {
            if (this.state.elements[i].identifier === identifier) {
                index = i;
                break;
            }
        }
        return index;
    }

    saveRefund(element) {
        this.setState({
            loadingDialog: true,
        });
        this.elementService.refundPayment(this.state.selectedElement.identifier, element)
            .then((response) => {
                const index = this.findIndexByIdentifier(this.state.selectedElement.identifier);
                let elements = [...this.state.elements];
                elements[index] = response.data.content;
                this.setState({
                    elements, refundDialog: false, loadingDialog: false, selectedElement: null,
                });
                this.toast.show({
                    severity: 'success', summary: I18n.t('REFUND'), detail: I18n.t('REFUND_SUCCESSFUL'), life: 6000
                });
            })
            .catch(error => {
                this.setState({
                    loadingDialog: false,
                });
                this.toast.show({
                    severity: 'error',
                    summary: I18n.t('REFUND'),
                    detail: I18n.t(error.response.data.code),
                    life: 6000
                });
            });
    }

    saveComment(element) {
        this.setState({
            loadingDialog: true,
        });
        this.elementService.addComment(this.state.selectedElement.identifier, element)
            .then((response) => {
                const index = this.findIndexByIdentifier(this.state.selectedElement.identifier);
                let elements = [...this.state.elements];
                elements[index] = response.data.content;
                this.setState({
                    elements, commentDialog: false, loadingDialog: false, selectedElement: null,
                });
                this.toast.show({
                    severity: 'success', summary: I18n.t('COMMENT'), detail: I18n.t('COMMENT_SUCCESSFUL'), life: 6000
                });
            })
            .catch(error => {
                this.setState({
                    loadingDialog: false,
                });
                this.toast.show({
                    severity: 'error',
                    summary: I18n.t('COMMENT'),
                    detail: I18n.t(error.response.data.code),
                    life: 6000
                });
            });
    }

    onPage(event) {
        this.setState({loading: true});
        const {page, first, rows} = event;
        this.loadData({
            businessIdentifier: this.props.business?.current?.identifier,
            isLive: this.props.business?.isBusinessProduction,
            start: page,
            pageSize: rows,
            sortField: this.state.sortFilterValue,
            order: this.state.sortFilterOrder,
            searchValue: this.state.searchFilterValue
        });
        this.setState({
            loading: false,
            first
        })
    }

    statusTemplate(rowData) {
        let component;
        if ("PENDING" === rowData.status) {
            component = <Tag rounded={true} icon="pi pi-clock" severity="info"
                             value={I18n.t(rowData.status + '_PAYMENT_DESCRIPTION')}></Tag>
        } else if ("CAPTURED" === rowData.status) {
            component = <Tag rounded={true} icon="pi pi-check" severity="success"
                             value={I18n.t(rowData.status + '_PAYMENT_DESCRIPTION')}></Tag>
        } else if ("FAILED" === rowData.status) {
            component = <Tag rounded={true} icon="pi pi-times" severity="danger"
                             value={I18n.t(rowData.status + '_PAYMENT_DESCRIPTION')}></Tag>
        } else if ("REFUND_FAILED" === rowData.status) {
            component = <Tag rounded={true} icon="pi pi-times" className="p-tag-outlined p-tag-warning"
                             value={I18n.t(rowData.status + '_PAYMENT_DESCRIPTION')}></Tag>
        } else if ("AUTHORIZED" === rowData.status) {
            component = <Tag rounded={true} icon="pi pi-clock" severity="info"
                             value={I18n.t(rowData.status + '_PAYMENT_DESCRIPTION')}></Tag>
        } else if ("CANCELLED" === rowData.status) {
            component = <Tag rounded={true} icon="pi pi-times" severity="danger"
                             value={I18n.t(rowData.status + '_PAYMENT_DESCRIPTION')}></Tag>
        } else if ("REFUNDED" === rowData.status) {
            component = <Tag rounded={true} icon="pi pi-check" severity="success"
                             value={I18n.t(rowData.status + '_PAYMENT_DESCRIPTION')}></Tag>
        } else if ("REFUNDING" === rowData.status) {
            component = <Tag rounded={true} icon="pi pi-clock" severity="info"
                             value={I18n.t(rowData.status + '_PAYMENT_DESCRIPTION')}></Tag>
        }

        return (
            component
        );
    }

    statTemplate() {
        return (<React.Fragment>
            <Button label="All: 28" className="p-button-raised p-mr-2"/>
            <Button label="Succeded: 10" className="p-button-raised p-button-success p-mr-2"/>
            <Button label="Refunded: 0" className="p-button-raised p-button-info p-mr-2"/>
            <Button label="Uncaptured: 22" className="p-button-raised p-button-warning p-mr-2"/>
            <Button label="Failed: 03" className="p-button-raised p-button-danger"/>
        </React.Fragment>)
    }

    leftToolbarTemplate() {
        return (<React.Fragment>
            <Dropdown value={this.state.sortFilterValue}
                      onChange={(e) => this.onGlobalFilterChange(e, 'sortFilter')}
                      options={this.state.sortFilterValues} optionLabel="name" placeholder={I18n.t('SELECT_ORDER')}/>
            <Dropdown style={{marginLeft: '7px'}} value={this.state.sortFilterValue}
                      onChange={(e) => this.onGlobalFilterChange(e, 'sortFilter')}
                      options={this.state.sortFilterValues} optionLabel="name" placeholder={I18n.t('SELECT_ORDER')}/>
            <Dropdown style={{marginLeft: '7px'}} value={this.state.sortFilterValue}
                      onChange={(e) => this.onGlobalFilterChange(e, 'sortFilter')}
                      options={this.state.sortFilterValues} optionLabel="name" placeholder={I18n.t('SELECT_ORDER')}/>
        </React.Fragment>)
    }

    rightToolbarTemplate() {
        return (<React.Fragment>
            <MultiSelect
                style={{marginRight: '7px'}}
                value={this.state.selectedColumns} options={this.state.transactionColumns}
                onChange={this.onTransactionColumnsChange}
                optionLabel="name" placeholder={I18n.t('EDIT_COLUMNS')}
                display="chip"
            />
            <Button label={I18n.t('EXPORT_DATA')} icon="pi pi-external-link" className="p-button-help"
                    onClick={this.exportCSV}/>
        </React.Fragment>)
    }

    searchTemplate() {
        return (<React.Fragment>
            <span className="p-input-icon-left">
                <div className="p-inputgroup">
                    <InputText placeholder={I18n.t('SEARCH_BY_BUSINESS_NAME_OR_REASON')}
                               onChange={e => this.setState({searchFilterValue: e.target.value})}
                               value={this.state.searchFilterValue}
                               style={{width: '400px'}}
                    />
                    <Button icon="pi pi-search" onClick={this.onSearch}/>
                </div>
            </span>
        </React.Fragment>)
    }

    loadData({businessIdentifier, isLive, start, pageSize, sortField, order, searchValue}) {
        this.setState({
            loading: true
        })
        let searchParams = [
            {field: 'business_identifier', value: businessIdentifier},
            {field: 'is_live', value: isLive}
        ]
        if (!!searchValue) {
            searchParams.push({field: 'search', value: searchValue});
        }

        let sortOrder = order === -1 ? Order.ASC : Order.DESC;
        this.elementService.getPage(
            start,
            pageSize,
            sortField,
            sortOrder,
            searchParams
        ).then(response => {
            this.setState({
                elements: response.data.content.list ? response.data.content.list : [],
                totalRecords: response.data.content.totalCount,
                loading: false
            })
        }).catch(error => {
            this.setState({
                loading: false
            });
        });
    }

    handleMenuToggle = (event, rowData) => {
        const ref = this.menuRefs.get(rowData.id);
        if (ref && ref.current) {
            ref.current.toggle(event);
        }
    };

    showDetailsElement(element) {
        this.setState({
            element, detailsElementDialog: true
        });
    }

    renderRefundFooter = () => {
        return (
            <>
                <Button type="button" loading={this.state.loadingDialog} label={I18n.t('CANCEL')}
                        icon="pi pi-times" className="p-button-text p-button-help"
                        onClick={this.hideElementDialog}/>
                <Button type="submit" loading={this.state.loadingDialog}
                        label={I18n.t('SAVE')}
                        icon="pi pi-check" className="p-button-text"
                        onClick={() => this.formikRefundRef.current?.submitForm()}
                />
            </>
        );
    }

    renderCommentFooter = () => {
        return (
            <>
                <Button type="button" loading={this.state.loadingDialog} label={I18n.t('CANCEL')}
                        icon="pi pi-times" className="p-button-text p-button-help"
                        onClick={this.hideElementDialog}/>
                <Button type="submit" loading={this.state.loadingDialog}
                        label={I18n.t('SAVE')}
                        icon="pi pi-check" className="p-button-text"
                        onClick={() => this.formikCommentRef.current?.submitForm()}
                />
            </>
        );
    }

    hideElementDialog() {
        this.formikRefundProps.initialValues = {
            amount: null,
            reason: ''
        };
        this.formikCommentProps.initialValues = {
            comment: ''
        };
        this.setState({
            refundDialog: false,
            commentDialog: false,
            loadingDialog: false,
            selectedElement: null
        });
    }

    editElement(element) {
        this.formikProps.initialValues = this.createInitialValues(element);
        this.setState({
            elementDialog: true
        });
    }


    manageRefund(element) {
        this.setState({
            refundDialog: true,
            selectedElement: element
        })
        this.formikRefundProps.initialValues.amount = element.businessAmount;
    }

    actionBodyTemplate = (rowData) => {
        if (!this.menuRefs.has(rowData.id)) {
            this.menuRefs.set(rowData.id, createRef());
        }

        const menuItems = [
            {
                label: I18n.t('DETAILS'),
                icon: 'pi pi-info-circle',
                command: () => this.showDetailsElement(rowData)
            },
            {
                label: I18n.t('ADD_COMMENT'),
                icon: 'pi pi-comment',
                command: () => this.setState({
                    commentDialog: true,
                    selectedElement: rowData
                })
            },
            {
                label: I18n.t('SHOW_HISTORY'),
                icon: 'pi pi-clock',
                command: () => this.showHistoryElement(rowData)
            }
        ]

        if ("CAPTURED" === rowData.status) {
            menuItems.push(
                {
                    label: I18n.t('REFUND'),
                    icon: 'pi pi-arrow-circle-left',
                    command: () => this.manageRefund(rowData)
                });
        }

        if ("CAPTURED" === rowData.status || "REFUNDED" === rowData.status) {
            menuItems.splice(1, 0, {
                label: I18n.t('SEE_INVOICE'),
                icon: 'pi pi-file',
                command: () => {
                    window.open(
                        rowData.invoiceUrl,
                        '_blank',
                        'noopener,noreferrer'
                    );
                }
            });
        }


        return (
            <div>
                <Button
                    icon="pi pi-ellipsis-h"
                    className="p-button-text"
                    onClick={(e) => this.handleMenuToggle(e, rowData)}
                />
                <Menu model={menuItems} popup ref={this.menuRefs.get(rowData.id)}/>
            </div>
        );
    };


    render() {
        const headerTemplate = () => {
            return (<React.Fragment>
                <div className="table-header">
                    <h5 className="p-mb-2">{I18n.t('TRANSACTIONS')}</h5>
                </div>
            </React.Fragment>);
        }

        const amountBodyTemplate = (data) => {
            return (
                <>
                    <span className="p-column-title">Total</span>
                    {formatAmount(data.amount, data.currencyCode, this.props.locale)}
                </>
            );
        };

        const feesBodyTemplate = (data) => {
            return (
                <>
                    <span className="p-column-title">{I18n.t('FEES')}</span>
                    {formatAmount(data.amount - data.businessAmount, data.currencyCode, this.props.locale)}
                </>
            );
        };

        const businessAmountBodyTemplate = (data) => {
            return (
                <>
                    <span className="p-column-title">{I18n.t('AMOUNT')}</span>
                    <span
                        className="p-text-bold">{formatAmount(data.businessAmount, data.currencyCode, this.props.locale)}</span>
                </>
            );
        };

        const reasonBodyTemplate = (data) => {
            const maxWords = 4;
            const words = data.reason?.split(' ') || [];
            const truncatedReason = words.length > maxWords
                ? words.slice(0, maxWords).join(' ') + '...'
                : data.reason;

            return (
                <>
                    <span className="p-column-title">{I18n.t('REASON')}</span>
                    {truncatedReason}
                </>
            );
        };

        const commentBodyTemplate = (data) => {
            const maxWords = 4;
            const words = data.comment?.split(' ') || [];
            const truncatedComment = words.length > maxWords
                ? words.slice(0, maxWords).join(' ') + '...'
                : data.comment;

            return (
                <>
                    <span className="p-column-title">{I18n.t('COMMENT')}</span>
                    {truncatedComment}
                </>
            );
        };

        const customerBodyTemplate = (data) => {
            return (
                <>
                    <span className="p-column-title">{I18n.t('CUSTOMER')}</span>
                    {data.fullName}
                </>
            );
        };

        const paymentDateBodyTemplate = (data) => {
            return (
                <>
                    <span className="p-column-title">Date</span>
                    {formatCustomDate(data.paymentDate, this.props.locale)}
                </>
            );
        };

        const availableOnBodyTemplate = (data) => {
            return (
                <>
                    <span className="p-column-title">{I18n.t('AVAILABLE_ON')}</span>
                    {formatCustomDate(data.availableOn, this.props.locale)}
                </>
            );
        };

        const transactionIdBodyTemplate = (data) => {
            return (
                <>
                    <span className="p-column-title">Id</span>
                    {data.transactionId}
                </>
            );
        };

        const quantityBodyTemplate = (data) => {
            return (
                <>
                    <span className="p-column-title">{I18n.t('QTY')}</span>
                    {data.quantity}
                </>
            );
        };

        const businessNameBodyTemplate = (data) => {
            return (
                <>
                    <span className="p-column-title">{I18n.t('BUSINESS_NAME')}</span>
                    {data.businessName}
                </>
            );
        };

        const providerBodyTemplate = (data) => {
            return (
                <>
                    <span className="p-column-title">{I18n.t('PAYMENT_METHOD')}</span>
                    <div style={{display: 'flex', alignItems: 'center'}}>
                        <img
                            alt=""
                            src={`/assets/provider/${data.provider?.toLowerCase()}.png`}
                            style={{height: '20px', marginRight: '0.5rem'}}
                        />
                        <span>{data.paymentMethodDetails}</span>
                    </div>
                </>
            );
        };

        return (<div className="crud-demo">
            <Toast ref={(el) => this.toast = el}/>
            <div className="card">
                <Toolbar left={headerTemplate} right={this.rightToolbarTemplate}/>
                <Toolbar left={this.statTemplate} right={this.searchTemplate}/>
                <DataTable ref={(el) => this.dt = el} value={this.state.elements}
                           lazy resizableColumns columnResizeMode="expand"
                           emptyMessage={I18n.t('NO_ITEMS_FOUND')}
                           selection={this.state.selectedElements}
                           onSelectionChange={(e) => this.setState({selectedElements: e.value})}
                           dataKey="id" paginator loading={this.state.loading}
                           rows={this.state.pageSize} totalRecords={this.state.totalRecords}
                           first={this.state.first} onPage={this.onPage}
                           paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
                           currentPageReportTemplate={I18n.t('PAGE_REPORT_TEMPLATE')}
                           sortMode="single"
                           onSort={this.customSort}
                           sortField={this.state.sortFilterValue}
                           sortOrder={this.state.sortFilterOrder}
                           responsive="true"
                           className="p-datatable-products"
                           showGridlines={false}
                >
                    <Column selectionMode="multiple" headerStyle={{width: '2rem'}}/>
                    <Column field="businessAmount" header={I18n.t('AMOUNT')} body={businessAmountBodyTemplate}
                            headerStyle={{width: '8rem'}}/>
                    {this.state.selectedColumns.includes('FEES') && (
                        <Column field="fees" header={I18n.t('FEES')} body={feesBodyTemplate}
                                headerStyle={{width: '6rem'}}/>
                    )}
                    {this.state.selectedColumns.includes('TOTAL') && (
                        <Column field="amount" header="Total" body={amountBodyTemplate}
                                headerStyle={{width: '8rem'}}/>
                    )}
                    <Column field="transactionId" header="Id" body={transactionIdBodyTemplate}
                            headerStyle={{width: '2rem'}}/>
                    {!this.props.business?.current?.identifier && (
                        <Column field="businessName" header={I18n.t('BUSINESS_NAME')}
                                body={businessNameBodyTemplate}/>
                    )}
                    <Column field="paymentMethod" header={I18n.t('PAYMENT_METHOD')} body={providerBodyTemplate}
                            headerStyle={{width: '16rem'}}/>
                    <Column header="Status" body={this.statusTemplate} headerStyle={{width: '10rem'}}/>
                    {this.state.selectedColumns.includes('REASON') && (
                        <Column field="reason" header={I18n.t('REASON')} body={reasonBodyTemplate}/>
                    )}
                    <Column field="fullName" header={I18n.t('CUSTOMER')} body={customerBodyTemplate}/>
                    {this.state.selectedColumns.includes('QUANTITY') && (
                        <Column field="quantity" headerStyle={{width: '3rem'}} header={I18n.t('QTY')}
                                body={quantityBodyTemplate}/>
                    )}
                    {this.state.selectedColumns.includes('COMMENT') && (
                        <Column field="comment" header={I18n.t('COMMENT')} body={commentBodyTemplate}/>
                    )}
                    <Column field="paymentDate" header="Date" body={paymentDateBodyTemplate}
                            headerStyle={{width: '12rem'}}/>
                    <Column field="availableOn" header={I18n.t('AVAILABLE_ON')} body={availableOnBodyTemplate}
                            headerStyle={{width: '12rem'}}/>
                    <Column headerStyle={{width: '4rem'}} body={this.actionBodyTemplate}/>
                </DataTable>
            </div>

            <Dialog visible={this.state.refundDialog} header={I18n.t('REFUND')} modal
                    breakpoints={{'960px': '75vw', '640px': '90vw'}} style={{width: '400px'}}
                    closable={false} onHide={this.hideElementDialog} footer={this.renderRefundFooter}
            >
                <Formik {...this.formikRefundProps} innerRef={this.formikRefundRef}>
                    {props => {
                        //console.log(props.values)
                        return <form onKeyDown={(event) => event.keyCode === 13 && event.preventDefault()}
                                     onSubmit={props.handleSubmit} className="p-fluid">
                            <div className="p-float-label p-field" style={{marginTop: '10px'}}>
                                <InputTextarea
                                    rows={1}
                                    autoResize
                                    name="reason"
                                    value={props.values.reason}
                                    onChange={props.handleChange}
                                    id="reason"
                                    className={classNames({'p-invalid': isFormFieldInvalid(props, 'reason')})}
                                />
                                <label htmlFor="reason"
                                       className={classNames({'p-error': isFormFieldInvalid(props, 'reason')})}>{I18n.t('REFUND_REASON')}*</label>
                                <small id="reason2" className="p-d-block">{I18n.t('REFUND_REASON_HINT')}</small>
                                {getFormErrorMessage(props, 'reason')}
                            </div>

                            <div className="p-float-label p-field" style={{marginTop: '10px'}}>
                                <InputNumber
                                    name="amount"
                                    value={props.values.amount}
                                    showButtons mode="decimal"
                                    locale={this.props.locale}
                                    minFractionDigits={1}
                                    maxFractionDigits={2}
                                    min={1}
                                    onValueChange={(e) => props.setFieldValue("amount", e.target.value)}
                                    id="amount"
                                    className={classNames({'p-invalid': isFormFieldInvalid(props, 'amount')})}
                                />
                                <label htmlFor="amount"
                                       className={classNames({'p-error': isFormFieldInvalid(props, 'amount')})}>
                                    {I18n.t('REFUND_AMOUNT')} (Max {this.state.selectedElement?.businessAmount})*
                                </label>
                                {getFormErrorMessage(props, 'amount')}
                            </div>
                        </form>
                    }}
                </Formik>
            </Dialog>

            <Dialog visible={this.state.commentDialog} header={I18n.t('ADD_COMMENT')} modal
                    breakpoints={{'960px': '75vw', '640px': '90vw'}} style={{width: '400px'}}
                    closable={false} onHide={this.hideElementDialog} footer={this.renderCommentFooter}
            >
                <Formik {...this.formikCommentProps} innerRef={this.formikCommentRef}>
                    {props => {
                        //console.log(props.values)
                        return <form onKeyDown={(event) => event.keyCode === 13 && event.preventDefault()}
                                     onSubmit={props.handleSubmit} className="p-fluid">
                            <div className="p-float-label p-field" style={{marginTop: '10px'}}>
                                <InputTextarea
                                    rows={1}
                                    autoResize
                                    name="comment"
                                    value={props.values.comment}
                                    onChange={props.handleChange}
                                    id="comment"
                                    className={classNames({'p-invalid': isFormFieldInvalid(props, 'comment')})}
                                />
                                <label htmlFor="comment"
                                       className={classNames({'p-error': isFormFieldInvalid(props, 'comment')})}>{I18n.t('YOUR_COMMENT')}*</label>
                                {getFormErrorMessage(props, 'comment')}
                            </div>
                        </form>
                    }}
                </Formik>
            </Dialog>

        </div>);
    }
}

function mapStateToProps(state) {
    const locale = state.i18n.locale;
    const business = state.business;
    return {
        locale,
        business
    };
}

export default connect(mapStateToProps)(Transaction);


